import React, { Component } from 'react';
import { TableBody as MaterialTableBody, TableCell, TableRow, withStyles } from '@material-ui/core';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from 'classnames';
import _ from 'lodash';

const styles = theme => ({
    NOOVERFLOW: {
        overflowY: 'hidden !important'
    },
    day: {
        backgroundColor: "#f5f5f5"
    },
    cell: {
        padding: '0 10px !important',
        textAlign: 'center',
        height: '49px',
        whiteSpace: 'nowrap'
    },
    cellError: {
        padding: '0px',
        textAlign: 'center',
        backgroundColor: 'white',
        height: '49px'
    },
    noPadding: {
        padding: '0 !important',
        textAlign: 'center'
    },
    cellWithBackground: {
        backgroundColor: 'white',
        padding: '0 20px',
        textAlign: 'center',
        height: '49px'
    },
    dense: {
        marginTop: 16,
    },
    noBorderBottom: {
        borderBottom: 0,
    },
    sideBorders: {
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        minWidth: '160px',
        backgroundColor: 'white'
    },
});

class TableBody extends Component {

    createMainTableCells = (row, classes) => {
        let tableCells = [];
        for (let [index, data] of row.entries()) {
            let value = data.value;
            tableCells.push(<TableCell key={index} className={classNames(classes.cell, classes.sideBorders)} >{value}</TableCell>);
        }
        return tableCells;
    }

    createDataviewTableCells = (row, classes, x) => {
        let { dataviewColumnsHeader } = this.props;

        var tableCells = [];
        for (const [index, data] of row.entries()) {
            let col = _.find(dataviewColumnsHeader, ['field', data.field]);
            if (col.show && typeof data.value !== "undefined") {
                let value = data.value
                switch (typeof value === 'string' && value.toLowerCase()) {
                    case 'true':
                        value = <FontAwesomeIcon icon={faCheck} />
                        break;
                    case 'null':
                    case 'false':
                        value = '';
                        break;
                    default:
                        break;
                }
                tableCells.push(<TableCell key={`${index}${x}`} className={classNames(classes.cell, classes.sideBorders)} >{value}</TableCell>)
            }
        };
        return tableCells;
    }

    render() {
        if (document.getElementById('WrapperTable'))
            document.getElementById('WrapperTable').classList.remove(this.props.classes.NOOVERFLOW);
        const { classes, rows,
            fixed, position } = this.props;
        if (fixed) {
            if (position === 'left') {
                let x = 0;
                return (
                    <MaterialTableBody>
                        {rows.map((row, index) => {
                            x++;
                            return (
                                <TableRow id={index} key={index} >
                                    {this.createDataviewTableCells(row.dataviewData, classes, x)}
                                </TableRow>
                            );
                        })}
                    </MaterialTableBody>
                );
            } else {
                return <MaterialTableBody visible={false}>
                    {rows.map((row, index) => {
                        return (''
                            // <TableRow id={index} key={index} >
                            //     <TableCell></TableCell>
                            //     {/* <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.yearTotal}</TableCell>
                            //         <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.day}</TableCell>
                            //         <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.evening}</TableCell>
                            //         <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.night}</TableCell> */}
                            // </TableRow>
                        );
                    })}
                </MaterialTableBody>
            }
        } else {
            return (
                <MaterialTableBody>
                    {rows.map((row, index) => {
                        // let borderClass = this.noBottomBorder(employee.id, index) ? classes.noBorderBottom : '';
                        // let shiftLine = employee.status[employee.statusIndex];
                        // let rightContent = showRight ? ([
                        //     <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.yearTotal}</TableCell>,
                        //     <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.day}</TableCell>,
                        //     <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.evening}</TableCell>,
                        //     <TableCell className={classNames(classes.cellWithBackground, borderClass)}>{employee.times.night}</TableCell>,
                        // ]) : '';
                        return (
                            <TableRow id={index} key={index} >
                                {this.createDataviewTableCells(row.dataviewData, classes, index)}
                                {this.createMainTableCells(row.mainData, classes)}
                                {/* {rightContent} */}
                                {/* <TableCell></TableCell> */}
                            </TableRow>
                        );
                    })}
                </MaterialTableBody>
            );
        }
    }
}

export default withStyles(styles)(TableBody);